import BuyerTooltipMobile from "assets/images/buyer-tooltip-mobile.png";
import BuyerTooltip from "assets/images/buyer-tooltip.png";
import DarkInfoIcon from "assets/images/info-icon-dark.png";
import InfoIconLight from "assets/images/info-icon-light.png";
import InfoIcon from "assets/images/info.png";
import PlusIcon from "assets/plus.png";
import { useEffect, useState } from "react";
import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import "./index.scss";

const PlatformFee = ({ light = false, serviceFee, noPadding = false }) => {
  const [showInfo, setShowInfo] = useState(false);
  const CurrentInfoIcon = light ? InfoIconLight : InfoIcon;

  // Function to handle clicks outside the info tooltip (also applies to plus icon)
  const handleOutsideClick = (event) => {
    if (event?.target?.className?.includes("info-")) {
      return;
    }

    setShowInfo(false);
  };

  // Effect to add/remove event listener for outside clicks
  useEffect(() => {
    if (showInfo) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showInfo]);

  return (
    <div
      className={`service-fee ${light ? "light-border" : ""} ${
        noPadding ? "no-padding" : ""
      }`}
    >
      <section className={`${light ? "light-font" : ""}`}>
        {serviceFee?.label || "Buyer Protection Fee"}:
        {showInfo && (
          <div className="info-tooltip">
            <img
              src={BuyerTooltip}
              alt="info-tooltip"
              className="info-tooltip-image"
            />
            <img
              src={BuyerTooltipMobile}
              alt="info-tooltip-mobile"
              className="info-tooltip-image-mobile"
            />
            <img src={PlusIcon} alt="plus-icon" className="plus-icon" />
          </div>
        )}
        <button onClick={() => setShowInfo(!showInfo)} className="info-btn">
          <img
            src={!showInfo ? CurrentInfoIcon : DarkInfoIcon}
            alt="dropdown"
            className="info-icon"
          />
        </button>
      </section>
      <section className={`checkout-value ${light ? "light-font" : ""}`}>
        {toMoneyWithTwoDecimalDigits(serviceFee?.amount)}
      </section>
    </div>
  );
};

export default PlatformFee;
